/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ProductType = {
	EasyClaim: 'EasyClaim',
	PolicyCheck: 'PolicyCheck',
	Steering: 'Steering',
	DamageAssesmentPoC: 'DamageAssesmentPoC',
} as const;
export type ProductType = (typeof ProductType)[keyof typeof ProductType];

export function instanceOfProductType(value: any): boolean {
	for (const key in ProductType) {
		if (Object.prototype.hasOwnProperty.call(ProductType, key)) {
			if (ProductType[key as keyof typeof ProductType] === value) {
				return true;
			}
		}
	}
	return false;
}

export function ProductTypeFromJSON(json: any): ProductType {
	return ProductTypeFromJSONTyped(json, false);
}

export function ProductTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductType {
	return json as ProductType;
}

export function ProductTypeToJSON(value?: ProductType | null): any {
	return value as any;
}

export function ProductTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ProductType {
	return value as ProductType;
}
